import { IAutomationObject } from '../../types'

export interface ISensorDigitalFault extends IAutomationObject {
    isErr: boolean;
    errDelay: number;
    errSum: boolean;
    overridden: boolean;
    outOfService: boolean;

    onValueChanged: any;

}

export const schema = 'AutomationApps.Devices.Sensors.SensorDigitalFault';
